import { render, staticRenderFns } from "./check_pay.vue?vue&type=template&id=2bdb0798&scoped=true&"
import script from "./check_pay.vue?vue&type=script&lang=js&"
export * from "./check_pay.vue?vue&type=script&lang=js&"
import style0 from "./check_pay.vue?vue&type=style&index=0&id=2bdb0798&scoped=true&lang=less&"
import style1 from "./check_pay.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb0798",
  null
  
)

export default component.exports